import React from 'react';

const Notfound = () => {
  return (
    <div>
      <h1 className='text-center m-5'>Page Not Found</h1>
    </div>
  );
}

export default Notfound;
